<template>
  <div class="container" v-if="item && isAdmin">
    <div class="row justify-content-md-center">
      <div class="col-12 col-md-8">
        <h1>
          <i
            v-if="item.provider"
            :class="`fa fa-${item.provider} fa-dim`"
            aria-hidden="true"
          ></i>
          {{ item.name }}
        </h1>
        <hr />
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-12 col-md-2 text-center">
        <img class="img-fluid" :src="item.image" />
        <p>
          <span
            v-for="role in item.roles"
            :key="role"
            class="badge badge-dark"
            >{{ role.toUpperCase() }}</span
          >
        </p>
      </div>
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-3">
            <ez-toggle v-model="item.active" :error="errors['active']"
              >Active</ez-toggle
            >
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row justify-content-md-center">
      <div class="col col-lg-6 text-center">
        <p>
          <button type="button" class="btn btn-primary" @click="patchData()">
            Save
          </button>
          <router-link class="btn btn-secondary" :to="`/users`"
            >Cancel</router-link
          >
        </p>
        <p>
          <router-link to="/users"
            ><i class="fa fa-angle-double-left"></i> Return to list</router-link
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import EzToggle from "../shared/_VueEzToggle.vue";
import EzInput from "../shared/_VueEzInput.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "user-edit",
  components: {
    EzToggle,
    EzInput,
    Multiselect
  },
  data() {
    return {
      errors: {}
    };
  },
  watch: {
    $route: "getData"
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters({
      isAdmin: "isAdmin",
      getOptions: "achievements/getOptions"
    }),
    ...mapState({
      user: state => state.session.user,
      item: state => state.users.current
    })
  },
  methods: {
    ...mapActions({
      usersEdit: "users/edit",
      usersUpdate: "users/update",
      usersClone: "users/clone",
      usersDestroy: "users/destroy"
    }),
    async getData() {
      try {
        if (this.isAdmin) {
          await this.usersEdit({ id: this.$route.params.id });
          this.$embers.pageData(this.item.name, this.item.summary);
        } else {
          this.$router.push({ path: `/404` });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async patchData() {
      try {
        await this.usersUpdate();
        this.$router.push({ path: `/users/${this.item._id}` });
      } catch (err) {
        console.error(err);
        this.errors = Object.assign({}, this.errors, err.response.data);
      }
    },
    async deleteData() {
      try {
        // await this.usersDestroy();
        this.$router.push({ path: `/users` });
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
